export default "__VITE_ASSET__087b7463__$_?nuxt_component=async__"